import { falImage } from 'shared/@generated/icons/falImage';
import { View } from 'react-native';
import { Icon } from 'shared/components/icon';

type CardMediaPlaceholderProps = {
  className?: string;
  iconClassName?: string;
  panelClassName?: string;
};

export function CardMediaPlaceholder({
  className = '',
  iconClassName = 'text-brand-brown-dark/35 size-10',
  panelClassName = 'bg-brand-cream-light/80 rounded-3xl p-4',
}: CardMediaPlaceholderProps) {
  return (
    <View className={`${className} bg-brand-cream items-center justify-center overflow-hidden`}>
      <View className={panelClassName}>
        <Icon icon={falImage} className={iconClassName} />
      </View>
    </View>
  );
}
